import { any, arrayOf, shape } from 'prop-types'

import Notification from 'views/components/molecules/Notification'

const ErrorNotifications = ({ errors, ...rest }) =>
  errors?.map((error, id) => (
    <div className="u-margin--bottom" key={`${error.props.id}_${id}`}>
      <Notification type="error" label={error} {...rest} />
    </div>
  ))

ErrorNotifications.propTypes = {
  errors: arrayOf(
    shape({
      id: any,
    })
  ),
}
ErrorNotifications.defaultProps = {
  errors: [],
}

export default ErrorNotifications
